$(document).ready(function() {

    function updateDeliveryInfo() {

        /* ✅ CHECK DROPSHIP CLASS */

        var isDropship = $('.prt_delivery.is-dropship').length > 0;


        /* ================================
           ✅ DROPSHIP PRODUCTS
        ================================= */

        if (isDropship) {

            console.log("Dropship Product Detected");

            $('.get_in_by_text_dropship')
                .text("Get it within 24 hrs");

            $('.delivery_text_dropship')
                .text("24 hrs");

            $('.h_delivery_dropship')
                .text("24");

            $('.start_delivery_dropship').text("");
            $('.end_delivery_dropship').text("");

            return; // ⛔ Stop timer logic
        }


        /* =================================
           ✅ NORMAL PRODUCTS (DYNAMIC TIMER)
        ================================= */

        var currentTime = new Date();
        var currentHour = currentTime.getHours();
        var currentMinute = currentTime.getMinutes();
        var currentSecond = currentTime.getSeconds();
        var currentDay = currentTime.getDay(); 
        
        if (currentHour === 0 && currentMinute === 0 && currentSecond === 0) {
            currentHour = 23;
            currentMinute = 59;
            currentSecond = 59;
        }
        
        var deliveryMessage = "";
        var cutoffTime;

        if (currentDay !== 5) {

            if (currentHour < 9 || (currentHour === 9 && currentMinute <= 45)) {

                cutoffTime = "09:45";
                deliveryMessage = "Get It By Today 1 PM";

            } else if (currentHour < 12 || (currentHour === 12 && currentMinute <= 45)) {

                cutoffTime = "12:45";
                deliveryMessage = "Get It By Today 4 PM";

            } else if (currentHour < 15 || (currentHour === 15 && currentMinute <= 45)) {

                cutoffTime = "15:45";
                deliveryMessage = "Get It By Today 7 PM";

            } else if (currentHour < 18 || (currentHour === 18 && currentMinute <= 45)) {

                cutoffTime = "18:45";
                deliveryMessage = "Get It By Today 10 PM";

            } else {

                cutoffTime = "23:59";
                deliveryMessage = "Get It By Tomorrow 1 PM";

            }

        } else {

            if (currentHour < 14 || (currentHour === 14 && currentMinute === 0)) {

                cutoffTime = "14:00";
                deliveryMessage = "Get it by Today";

            } else {

                cutoffTime = "23:59";
                deliveryMessage = "Get it tomorrow by 1 PM";

            }

        }

        if (deliveryMessage !== "") {

            var cutoffHour = parseInt(cutoffTime.split(":")[0]);
            var cutoffMinute = parseInt(cutoffTime.split(":")[1]);

            var remainingHours = cutoffHour - currentHour;
            var remainingMinutes = cutoffMinute - currentMinute;
            var remainingSeconds = 60 - currentSecond;
            
            if (remainingSeconds === 60) {
                remainingSeconds = 0;
                remainingMinutes++;
            }
            
            if (remainingMinutes < 0) {
                remainingHours--;
                remainingMinutes += 60;
            }
            
            if (remainingHours < 0) {
                remainingHours += 24;
            }

            var text_hour = (remainingHours === 1) ? "hour" : "hours";
            var text_mins = (remainingMinutes === 1) ? "min" : "mins";


            /* ✅ UPDATE NORMAL PRODUCTS */

            $('.get_in_by_text_dropship')
                .text(deliveryMessage);

            $('.delivery_text_dropship')
                .text(
                    remainingHours + " " +
                    text_hour + " " +
                    remainingMinutes + " " +
                    text_mins
                );

        }

    }

    /* Initial Run */
    updateDeliveryInfo();

    /* Run every minute */
    setInterval(updateDeliveryInfo, 60000);

    /* Re-run on click */
    $(document).on("click", ".hover_button a", function() {
        updateDeliveryInfo();
    });

});